import * as requestFromServer from "./NoticeGroupsCrud";
import { noticeGroupSlice, callTypes } from "./NoticeGroupsSlice";

const {actions} = noticeGroupSlice;

export const getNoticeGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getNoticeGroups(queryParams)
    .then(response => {
      dispatch(actions.noticeGroupsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllNoticeGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllNoticeGroups(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getNoticeGroup = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
      .getNewNoticeGroup()
      .then(response => {
        dispatch(actions.noticeGroupFetched(response.data));
      })
      .catch(error => {
        
      });
  }
  
  return requestFromServer
    .getNoticeGroup(id)
    .then(response => {
      dispatch(actions.noticeGroupFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveNoticeGroup = noticeGroup => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveNoticeGroup(noticeGroup)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteNoticeGroups = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteNoticeGroups(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanNoticeGroupsState = () => dispatch => {
  dispatch(actions.noticeGroupsStateCleaned());
}